<mat-toolbar>
  Wax price : {{(waxPrice$ | async)}}
  <span class="spacer"></span>
  <button mat-raised-button (click)="login()" *ngIf="!waxService.userAccount">Log In</button>
</mat-toolbar>
<h1>Live Drops</h1>
<mat-card *ngFor="let drop of (liveDrops$ | async)">
  <mat-card-title>#{{drop.drop_id}}</mat-card-title>
  <mat-card-subtitle>#{{drop.collection_name}}</mat-card-subtitle>
  <mat-card-content>
    <div *ngIf="(assets$[drop.collection_name + drop.assets_to_mint[0].template_id] | async) as asset">
      <img [src]="image(asset.img)">
      <h3>{{asset.name}}</h3>
      {{asset.description}}
    </div>
    <span *ngIf="drop.end_time > 0">Time left : <countdown [config]="countdownConfig(drop, true)"></countdown></span><br>
    Claimed : {{drop.current_claimed}} / {{drop.max_claimable}}<br>
    Claims per person : {{drop.account_limit}}<br>
    Price : {{price(drop.listing_price)}}<br>
    Quantity : <input type="number" min="1" [max]="drop.account_limit || (drop.max_claimable ? drop.max_claimable - drop.current_claimed : 999999)" value="1" #dropQuantity><br>
    <button mat-raised-button *ngIf="(waxPrice$ | async) as waxPrice" (click)="claimDrop(drop, waxPrice, dropQuantity.value)" [disabled]="!waxService.userAccount">{{waxService.userAccount ? 'Claim drop' : 'Login first !'}}</button>
  </mat-card-content>
</mat-card>
<div class="clearfix"></div>
<h1>Upcoming Drops</h1>
<mat-card *ngFor="let drop of (upcomingDrops$ | async)">
  <mat-card-title>#{{drop.drop_id}}</mat-card-title>
  <mat-card-subtitle>#{{drop.collection_name}}</mat-card-subtitle>
  <mat-card-content>
    <div *ngIf="(assets$[drop.collection_name + drop.assets_to_mint[0].template_id] | async) as asset">
      <img [src]="image(asset.img)">
      <h3>{{asset.name}}</h3>
      {{asset.description}}
    </div>
    Opens in : <countdown *ngIf="(waxPrice$ | async) as waxPrice" [config]="countdownConfig(drop, false)" (event)="dropOpen($event, drop, waxPrice, dropQuantity.value, autoclaim.checked)"></countdown><br>
    Claims per person : {{drop.account_limit}}<br>
    Price : {{price(drop.listing_price)}}<br>
    Quantity : <input type="number" min="1" [max]="drop.account_limit || drop.max_claimable" value="1" #dropQuantity><br>
    <mat-checkbox #autoclaim>Enable autoclaim</mat-checkbox><br>
    <button mat-raised-button *ngIf="(waxPrice$ | async) as waxPrice" (click)="claimDrop(drop, waxPrice, dropQuantity.value)" [disabled]="!waxService.userAccount">{{waxService.userAccount ? 'Test transaction' : 'Login first !'}}</button>
  </mat-card-content>
</mat-card>
